import {combineReducers, Reducer} from 'redux';
import recipientStore from './CrReducer';
import visitDraftStore from './VisitDraftReducer';
import visitStore from './VisitReducer';
import pricingStore from './PricingReducer';
import sideMenuStoreReducer from './SideMenuReducer';
import {CustomSelectReducer} from './CustomSelectReducer';
import careOwnerReducer from 'Screens/CareOwner/reducer';
import {SideMenuState} from 'Components/SideBar/types';

// All reducers combined

export interface ApplicationState {
  careOwnerStore: any;
  customSelectStore: any;
  pricingStore: any;
  recipientStore: any;
  sideMenuStore: SideMenuState;
  visitDraftStore: any;
  visitStore: any;
}

// Redux 5's combineReducers inference is stricter; keep the app state contract explicit.
export const reducers = combineReducers({
  careOwnerStore: careOwnerReducer,
  customSelectStore: CustomSelectReducer,
  pricingStore,
  recipientStore,
  sideMenuStore: sideMenuStoreReducer,
  visitDraftStore,
  visitStore,
}) as Reducer<ApplicationState>;
